module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaklEQVQ4T62TyytEcRTHP+fOtRGyoMykzFb8AZYWFCuzka6yojxKUWqmbIkpmoXyiI2Nm6RYzcZilrNHLNlgMaVcKfyao3s95sGUjN/u1znnc17fI5Q9jTsdwBhCH9D6Yb5COQF2JOmeF4fI50e7u226IimUGKKbmPwxT/mrwF5rRbGtAVQmEI7I3sxKJmN8UwB4Dw6nUe7wzKSsHzyWVxb4TQ3WUW9vILSQve33Ie+AxPAaqo2SdEd+CvyhTReRnCzvTYvODXUSCqXxXtsrZf4GCCqpucA894rGnRRCTpbdxd9k/5pZwplHaRJNOBeY/KCs7J8VAzTujAMLIDaWzsiSu1ti9yu3LdcHeDyYcHn5Gh++R2gMglRzknSbSwB+Gw327b8ATjF55+8tVD3EatdYtZAKUo6kUf2NlLcRaSJ7U5ByEaRwTMoRnrkOVldvtyHEKh7TN4GErFGEHiBacs7mZUtWDy+L/d8AWNrVc11jlTAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/weikaishi.png
// module id = GHdz
// module chunks = 96